import { ArrowDropDown } from "@mui/icons-material";
import { Button, Menu, MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { SaveAndExit } from "../icons";

const StyledMenu = styled(Menu)(() => ({
    "& .MuiMenuItem-root": {
        color: "#2C99D2",
        fontWeight: 600,

        "&:hover": {
            backgroundColor: "rgba(44, 153, 210, 0.08)",
        },
    },
    "& .MuiList-root": {
        paddingTop: 0,
        paddingBottom: 0,
    },
}));

const StyledMenuItem = styled(MenuItem)(() => ({
    fontSize: "14px",
    fontWeight: 600,
    color: "#2c99d2",
    backgroundColor: "white",
    border: "1px solid rgba(44, 153, 210, .5)",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    "&:hover": {
        backgroundColor: "1px solid rgba(44, 153, 210, .5)",
        borderColor: "#2C99D2",
    },
    "& svg": {
        color: "#2C99D2",
    },
}));

const StyledArrowButton = styled(Button)(() => ({
    flexGrow: 1,
    backgroundColor: "white",
    color: "#2c99d2",
    border: "1px solid rgba(44, 153, 210, .5)",
    borderLeft: "1px solid rgba(44, 153, 210, .25)",
    borderRadius: "0 4px 4px 0",
    width: "25%",
    minWidth: "30px",
    padding: "6px 0",
    margin: "0px",
    "&:hover": {
        border: "1px solid #2c99d2",
        borderLeft: "1px solid #2c99d2",
        backgroundColor: "rgba(44, 153, 210, 0.08)",
    },
    "&:active, &.Mui-focusVisible": {
        backgroundColor: "#1e6b93",
        color: "white",
        borderColor: "#1e6b93",
    },
    "&:disabled": {
        backgroundColor: "initial",
        color: "rgba(0, 0, 0, .26)",
        border: "1px solid rgba(0, 0, 0, .26)",
    },
}));

const StyledSaveButton = styled(Button)(() => ({
    flexGrow: 3,
    backgroundColor: "white",
    color: "#2c99d2",
    border: "1px solid rgba(44, 153, 210, .5)",
    borderRight: "none",
    borderRadius: "4px 0 0 4px",
    width: "75%",
    padding: "4px 8px",
    "&:hover": {
        border: "1px solid #2c99d2",
        backgroundColor: "rgba(44, 153, 210, 0.08)",
    },
    "&:active, &.Mui-focusVisible": {
        backgroundColor: "#1e6b93",
        color: "white",
        borderColor: "#1e6b93",
    },
    "&:disabled": {
        backgroundColor: "initial",
        color: "rgba(0, 0, 0, .26)",
        border: "1px solid rgba(0, 0, 0, .26)",
    },
}));

const SaveAndExitButton = ({ onSave, onSaveAndExit, disabled = false }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSaveAndRedirect = () => {
        onSaveAndExit?.();
        handleClose();
    };

    return (
        <React.Fragment>
            <div style={{ display: "flex", height: "36px", position: "relative" }}>
                <StyledSaveButton onClick={onSave} disabled={disabled}>
                    Save
                </StyledSaveButton>
                <StyledArrowButton onClick={handleMenuClick} disabled={disabled}>
                    <ArrowDropDown />
                </StyledArrowButton>
            </div>
            <StyledMenu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                slotProps={{
                    paper: {
                        sx: {
                            mt: 0.5,
                        },
                    },
                }}
            >
                <StyledMenuItem onClick={handleSaveAndRedirect}>
                    <SaveAndExit /> Save & Exit
                </StyledMenuItem>
            </StyledMenu>
        </React.Fragment>
    );
};

SaveAndExitButton.propTypes = {
    onSave: PropTypes.func,
    onSaveAndExit: PropTypes.func,
    disabled: PropTypes.bool,
};

export default SaveAndExitButton;
